export default ({ request }) => ({
  ecomAmzPriceControlParamsListApi(data = {}) {
    return request({
      url: '/ecom/amz/price/control/params/list',
      method: 'post',
      data,
    })
  },
  ecomAmzPriceControlParamsDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/price/control/params/detail',
      method: 'post',
      data,
    })
  },
  ecomAmzPriceControlParamsSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/price/control/params/save',
      method: 'post',
      data,
    })
  },
  ecomAmzPriceControlParamsDelApi(data = {}) {
    return request({
      url: '/ecom/amz/price/control/params/del',
      method: 'post',
      data,
    })
  },
  ecomAmzPriceControlParamsReviewApi(data = {}) {
    return request({
      url: '/ecom/amz/price/control/params/review',
      method: 'post',
      data,
    })
  },
  ecomAmzPriceControlParamsCopyApi(data = {}) {
    return request({
      url: '/ecom/amz/price/control/params/copy',
      method: 'post',
      data,
    })
  },
  ecomAmzPriceControlParamsDetailPriceApi(data = {}) {
    return request({
      url: '/ecom/amz/price/control/params/detail/price',
      method: 'post',
      data,
    })
  },
})
